import store from '../store/Store';
import { BrandListLoadState } from '../store/schema/BrandList';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'SET_BRAND_LIST_LOAD_STATE',
    (brandListLoadState: BrandListLoadState) => {
        store.brandListLoadState = brandListLoadState;
    }
);
